(function ($, Promise) {

        // Constructor
        function PACGrandePaixScreenSaver() {

            this.counter = 0;
            this.state = true;
            this.ticker = new PIXI.Ticker();

            // Init game canvas (PIXI)
            this.canvas = $("#screensaver-canvas").get(0);
            this.renderer = PIXI.Renderer.create({
                width: 1920,
                height: 1080,
                backgroundColor: 0x272625,
                view: this.canvas,
                resolution: 1,
                antialias: true,
                // resolution: window.devicePixelRatio || 1,
            });

            this.pageSprites = [];
            this.stage = new PIXI.Container();

            // Add page 1
            var page1Texture = PIXI.Texture.from('images/grande_paix/screensaver/page01.jpg');
            this.pageSprites[0] = new PIXI.Sprite(page1Texture);
            this.pageSprites[0].anchor.set(0.5);
            this.pageSprites[0].position.set(-500, 1080 / 2);
            this.pageSprites[0].blendMode = PIXI.BLEND_MODES.MULTIPLY;
            this.pageSprites[0].baseRotation = 0.1;
            this.pageSprites[0].speedFactor = 0.9;
            this.pageSprites[0].scale.set(0.8);
            this.stage.addChild(this.pageSprites[0]);

            // Add page 2
            var page2Texture = PIXI.Texture.from('images/grande_paix/screensaver/page03.jpg');
            this.pageSprites[1] = new PIXI.Sprite(page2Texture);
            this.pageSprites[1].anchor.set(0.5);
            this.pageSprites[1].position.set(500, 1080 / 2);
            this.pageSprites[1].blendMode = PIXI.BLEND_MODES.MULTIPLY;
            this.pageSprites[1].baseRotation = -0.1;
            this.pageSprites[1].speedFactor = 1.1;
            this.pageSprites[1].scale.set(0.95);
            this.stage.addChild(this.pageSprites[1]);

            // Add page 3
            var page3Texture = PIXI.Texture.from('images/grande_paix/screensaver/page04.jpg');
            this.pageSprites[2] = new PIXI.Sprite(page3Texture);
            this.pageSprites[2].anchor.set(0.5);
            this.pageSprites[2].position.set(1500, 1080 / 2);
            this.pageSprites[2].blendMode = PIXI.BLEND_MODES.MULTIPLY;
            this.pageSprites[2].baseRotation = -0.1;
            this.pageSprites[2].speedFactor = 1.09;
            this.pageSprites[2].scale.set(0.8);
            this.stage.addChild(this.pageSprites[2]);

            // Add page 3
            var page3Texture = PIXI.Texture.from('images/grande_paix/screensaver/page03.jpg');
            this.pageSprites[3] = new PIXI.Sprite(page3Texture);
            this.pageSprites[3].anchor.set(0.5);
            this.pageSprites[3].position.set(2500, 1080 / 2);
            this.pageSprites[3].blendMode = PIXI.BLEND_MODES.MULTIPLY;
            this.pageSprites[3].baseRotation = 0.15;
            this.pageSprites[3].speedFactor = 0.7;
            this.pageSprites[3].scale.set(0.9);
            this.stage.addChild(this.pageSprites[3]);

            // Listen for animate update
            this.ticker.add($.proxy(this.draw, this));
        }

        PACGrandePaixScreenSaver.prototype.start = function () {
            this.state = true;

            for (var i = 0; i < this.pageSprites.length; i++) {
                this.pageSprites[i].alpha = 1;
            }

            this.ticker.start();
        }

        PACGrandePaixScreenSaver.prototype.stop = function () {
            this.ticker.stop();
            this.state = false;
        }

        PACGrandePaixScreenSaver.prototype.animateOut = function () {
            for (var i = 0; i < this.pageSprites.length; i++) {
                TweenMax.to(this.pageSprites[i], 0.6 * this.pageSprites[i].speedFactor, {
                    alpha: 0,
                    ease: this.defaultEasing,
                    onComplete: this.stop,
                    onCompleteScope: this,
                });
            }
        }

        // Load settings JSON (with promise)
        PACGrandePaixScreenSaver.prototype.draw = function (delta) {

            this.counter += delta;

            if (!this.stopped) {
                for (var i = 0; i < this.pageSprites.length; i++) {
                    this.pageSprites[i].position.x += 0.65 * delta;
                    this.pageSprites[i].rotation = this.pageSprites[i].baseRotation + (Math.sin(this.counter * 0.002 * this.pageSprites[i].speedFactor) * 0.05);
                    this.pageSprites[i].position.y -= (0.08 * delta * this.pageSprites[i].speedFactor) * (i % 2 == 0 ? -1 : 1);

                    if (this.pageSprites[i].position.x > 2700) {
                        this.pageSprites[i].position.x = -1000;
                        this.pageSprites[i].position.y = 1080 / 2;
                    }
                }
            }

            // Trigger rendering
            this.renderer.render(this.stage);
        }

        PACGrandePaixScreenSaver.prototype.reset = function () {

        }

        // Expose PACGrandePaixScreenSaver
        window.PACGrandePaixScreenSaver = PACGrandePaixScreenSaver;
    }
)
(jQuery, Promise);
